import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './CategoryPills.styles';
const CategoryPills = (props) => {
    if (props.links == null || props.links.length === 0) {
        return null;
    }
    return (React.createElement(S.Container, null, props.links.map((link) => (React.createElement(FocusRing, { key: link.id, focusRingClass: "focus-ring" },
        React.createElement(S.Pill, { onClick: (e) => followLink(e, link), tabIndex: props.tabIndex, pillColour: link.pillColour || undefined }, link.text))))));
    /* Use JS to open link due to pills appearing inside link cards */
    function followLink(e, link) {
        e.preventDefault();
        window.open(link.url, link.target)?.focus();
    }
};
export default CategoryPills;
